import { render, staticRenderFns } from "./properties-block-spacer.vue?vue&type=template&id=59c1d887&scoped=true"
import script from "./properties-block-spacer.vue?vue&type=script&lang=js"
export * from "./properties-block-spacer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c1d887",
  null
  
)

export default component.exports